import { lazy } from "react";
import { Navigate } from "react-router-dom";

const SQLActivityOverview_V2 = lazy(
  () => import("pages/Performance/Activity_V2/Overview/MonitoringSQLActivityOverview")
);

const WhatHappened_V2 = lazy(() => import("pages/Performance/WhatHappened_V2/WhatHappened"));
const SQLActivityCompare_V2 = lazy(
  () => import("pages/Performance/Activity_V2/Compare/MonitoringSQLActivityCompare")
);
const DbAvailabilityGroupsOverview = lazy(
  () => import("pages/Performance/AvailabilityGroups_V2/AvailabilityGroupsOverview")
);
const DbBlockingOverview = lazy(
  () => import("pages/Performance/Blocking_V2/Overview/MonitoringBlockingOverview")
);
const DbBlockingReport = lazy(
  () => import("pages/Performance/Blocking_V2/Details/MonitoringBlockingReport")
);
const DbDeadlocksOverview = lazy(
  () => import("pages/Performance/Deadlocks_V2/Overview/MonitoringDeadlocksOverview")
);
const DbDeadlocksReport = lazy(
  () => import("pages/Performance/Deadlocks_V2/Details/MonitoringDeadlocksReport")
);

const DbJobsOverview = lazy(() => import("pages/Performance/Jobs_V2/Overview/JobsOverview"));
const DbJobsDetails = lazy(() => import("pages/Performance/Jobs_V2/Details/JobsDetails"));
const DbIndexOverview = lazy(
  () => import("pages/Performance/IndexStatistics/Overview/IndexOverview")
);
const DbIndexDetails = lazy(() => import("pages/Performance/IndexStatistics/Details/IndexDetails"));
const DbQueryStatsOverview = lazy(
  () => import("pages/Performance/QueryStats_V2/Overview/QueryStatsOverview")
);
const DbQueryStatsDetails = lazy(
  () => import("pages/Performance/QueryStats_V2/Details/QueryStatsDetails")
);

const SQLConnectionsOverview_V3 = lazy(
  () => import("pages/Performance/Connections_V2/Overview/ConnectionsOverview")
);

const SQLConnectionsDetails_V3 = lazy(
  () => import("pages/Performance/Connections_V2/Details/ConnectionsDetails")
);

export const performance = [
  {
    path: "performance",
    element: <Navigate to="sql_activity_overview" replace />,
  },
  {
    path: "performance",
    children: [
      {
        path: "sql_activity_overview",
        element: <SQLActivityOverview_V2 />,
      },
      {
        path: "what_happened",
        element: <WhatHappened_V2 />,
      },
      {
        path: "sql_activity_compare",
        element: <SQLActivityCompare_V2 />,
      },
      {
        path: "blocking_overview",
        element: <DbBlockingOverview />,
      },
      {
        path: "blocking_details",
        element: <DbBlockingReport />,
      },
      {
        path: "deadlocks_overview",
        element: <DbDeadlocksOverview />,
      },
      {
        path: "deadlocks_details",
        element: <DbDeadlocksReport />,
      },
      {
        path: "jobs_overview",
        element: <DbJobsOverview />,
      },
      {
        path: "jobs_details",
        element: <DbJobsDetails />,
      },
      {
        path: "index_overview",
        element: <DbIndexOverview />,
      },
      {
        path: "index_details",
        element: <DbIndexDetails />,
      },
      {
        path: "query_statistics_overview",
        element: <DbQueryStatsOverview />,
      },
      {
        path: "query_statistics_details",
        element: <DbQueryStatsDetails />,
      },
      {
        path: "connections_overview",
        element: <SQLConnectionsOverview_V3 />,
      },
      {
        path: "connections_details",
        element: <SQLConnectionsDetails_V3 />,
      },
      {
        path: "availability_groups_overview",
        element: <DbAvailabilityGroupsOverview />,
      },
    ],
  },
];
